import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const Lazy = lazy(
  () => import(/* webpackChunkName: 'Tally Embed' */ './index'),
);

export default function TallyEmbed(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <Lazy {...props} />
    </Suspense>
  );
}
